<template>
  <div class="product-container">
    <!--    <div class="product-front">-->
    <!--      <p>全系产品细细看。</p>-->
    <!--    </div>-->

    <!-- Web端展示 -->
    <div class="products-wrapper web-view">
      <!-- 三个产品内容保持不变 -->
      <div ref="show-products" class="show-products" v-for="(product, index) in products" :key="'web-'+index">
        <!-- 产品内容结构保持不变 -->
        <div class="top1-image">
          <img :src="product.image" :alt="product.name">
        </div>
        <div class="show-content">
          <p style="font-size: 1.2em">{{ product.name }}</p>
          <p style="font-size: 1.2em">{{ product.model }}</p>
          <p style="font-size: 1.2em">{{ product.description }}</p>
          <!--          <p :style="{color: product.priceColor}">{{ product.price }}</p>-->
        </div>
        <div class="show-content2">
          <span>{{ $t('series.products_one_desc3') }}<span class="cm-show"> {{ product.maxHeight }}<br></span></span>
          <span>{{ $t('series.products_one_desc4') }}<span class="cm-show" :style="{color: product.lengthColor}"> {{
              product.validLength
            }}<br></span></span>
          <span>{{ product.knifeSize }}<br></span>
          <span>{{ $t('series.products_one_desc5') }}</span>
        </div>
        <div class="show-content3">
          <img src="../../static/series/top-image2.png" alt="">
          <p>{{ product.galaxyModel }}</p>
          <p>{{ product.galaxySpec1 }}</p>
          <p>{{ product.galaxySpec2 }}</p>
        </div>
      </div>
    </div>

    <!-- 移动端轮播展示 -->
    <div class="mobile-view">
      <div class="carousel-container">
        <div class="carousel-slide" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
          <div class="show-products" v-for="(product, index) in products" :key="'mobile-'+index">
            <!-- 产品内容结构保持不变 -->
            <div class="top1-image">
              <img :src="product.image" :alt="product.name">
            </div>
            <div class="show-content">
              <p>{{ product.name }}</p>
              <p>{{ product.model }}</p>
              <p>{{ product.description }}</p>
              <!--              <p :style="{color: product.priceColor}">{{ product.price }}</p>-->
            </div>
            <div class="show-content2">
              <span>最大裁剪高度<span class="cm-show"> {{ product.maxHeight }}<br></span></span>
              <span>有效裁剪区长度<span class="cm-show" :style="{color: product.lengthColor}"> {{ product.validLength }}<br></span></span>
              <span>{{ product.knifeSize }}<br></span>
              <span>裁刀尺寸</span>
            </div>
            <div class="show-content3">
              <img src="../../static/series/top-image2.png" alt="">
              <p>{{ product.galaxyModel }}</p>
              <p>{{ product.galaxySpec1 }}</p>
              <p>{{ product.galaxySpec2 }}</p>
            </div>
          </div>
        </div>
        <span class="iconfont icon-xiangzuo"></span>
        <button class="carousel-btn prev" @click="prevSlide" :disabled="currentIndex === 0">
          <span class="iconfont icon-xiangzuo1"></span>
        </button>
        <button class="carousel-btn next" @click="nextSlide" :disabled="currentIndex === products.length - 1">
          <span class="iconfont icon-xiangyou1"></span>
        </button>


        <div class="carousel-indicators">
          <span v-for="(product, index) in products"
                :key="'indicator-'+index"
                :class="{ active: currentIndex === index }"
                @click="goToSlide(index)">
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import image1 from '../../static/series/top-image1.png'
import image2 from '../../static/series/top-image3.png'

export default {
  data() {
    return {
      currentIndex: 0,
      products: [
        {
          name: this.$i18n.t('series.products_one_desc1'),
          model: "1818/1820/1822",
          description: this.$i18n.t('series.products_one_desc2'),
          price: "RMB 510,000 起",
          priceColor: "#d86ecc",
          maxHeight: "6cm",
          validLength: "1.8m",
          lengthColor: "black",
          knifeSize: "2.0 × 7.0 mm",
          galaxyModel: "Galaxy Ma50 + 30kw",
          galaxySpec1: "-21kp",
          galaxySpec2: this.$i18n.t('series.products_one_desc6'),
          image: image1
        },
        {
          name: this.$i18n.t('series.products_one_desc8'),
          model: "1818/1820/1822",
          description: this.$i18n.t('series.products_one_desc9'),
          price: "RMB 530,000 起",
          priceColor: "#46b1e1",
          maxHeight: "9cm",
          validLength: "1.8m",
          lengthColor: "black",
          knifeSize: "2.4 × 8.5 mm",
          galaxyModel: "Galaxy Ma50 + 30kw",
          galaxySpec1: "-21kp",
          galaxySpec2: this.$i18n.t('series.products_one_desc6'),
          image: image2
        },
        {
          name: this.$i18n.t('series.products_one_desc10'),
          model: "2520/2522",
          description: this.$i18n.t('series.products_one_desc11'),
          price: "RMB 580,000 起",
          priceColor: "#46b1e1",
          maxHeight: "9cm",
          validLength: "2.5m",
          lengthColor: "#46b1e1",
          knifeSize: "2.4 × 8.5 mm",
          galaxyModel: "Galaxy Ma55 + 45kw",
          galaxySpec1: "-24kp",
          galaxySpec2: this.$i18n.t('series.products_one_desc7'),
          image: image2
        }
      ]
    }
  },
  methods: {
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    nextSlide() {
      if (this.currentIndex < this.products.length - 1) {
        this.currentIndex++
      }
    },
    goToSlide(index) {
      this.currentIndex = index
    }
  },
  mounted() {
    this.$nextTick(() => {
      // .product-front  ref=show-products
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          // trigger: ['.product-front', this.$refs['show-products']],
          trigger: [this.$refs['show-products']],
          start: 'top 80%',
          end: 'bottom 20%',
          markers: false,
          // scrub: 1,
          toggleActions: 'play none none none',
          once: true
        }
      })

      masterTimeline.from('.product-front', {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: 'power2.out'
      })

      this.$refs['show-products'].forEach((item, index) => {
        masterTimeline.from(item, {
          opacity: 0,
          y: 100,
          duration: 1,
          ease: 'power2.out'
        }, index * 0.3)
      })
    })
  }
}
</script>

<style scoped>
.product-container {
  width: 100%;
  background-color: rgba(245, 245, 247);
  margin-top: 200px;
  padding: 35px 0;
}

.product-front {
  margin: 0 auto 50px;
  padding-left: 50px;
  display: flex;
  justify-content: left;
  width: 90%;

  p {
    font-size: 3em;
    max-width: 100%;
  }
}

/* Web端样式 */
.products-wrapper.web-view {
  display: flex;
  justify-content: center;
  gap: 30px;
  width: 90%;
  margin: 0 auto;
  flex-wrap: wrap;
}

.show-products {
  width: 28%;
  min-width: 250px;
  padding: 0 20px;
  box-sizing: border-box;
}

.top1-image {
  height: 150px;
}

img {
  width: 90%;
  object-fit: contain;
}

.show-content {
  margin-top: 2vw;
  font-size: 0.85em;
  width: 100%;
}

.show-content p {
  max-width: 100%;
}

.show-content p:nth-of-type(1) {
  margin-bottom: 0;
  margin-top: 0px;
}

.show-content p:nth-of-type(2) {
  margin-bottom: 0;
  margin-top: 0px;
}

.show-content p:nth-of-type(3) {
  color: #808080;
  margin-bottom: 7px;
  margin-top: 0px;
}

.show-content p:nth-of-type(4) {
  margin-bottom: 0;
}

.show-content2 {
  margin-top: 30px;
  font-size: 1em;
  color: black;
}

.cm-show {
  color: black;
  font-size: 1.5em;
}

.show-content2 span:nth-of-type(1),
.show-content2 span:nth-of-type(2),
.show-content2 span:nth-of-type(4) {
  color: black;
}

.show-content2 span:nth-of-type(3) {
  font-size: 1.3em;
}

.show-content3 {
  margin-top: 15px;
}

.show-content3 img {
  width: 100px;
  height: 100px;
}

.show-content3 p:nth-of-type(1) {
  margin-bottom: 0px;
  max-width: 100%;
}

.show-content3 p:nth-of-type(2),
.show-content3 p:nth-of-type(3) {
  max-width: 100%;
  margin-bottom: 0px;
  text-align: center;
  color: #808080;
  font-size: 0.8em;
}

/* 移动端样式 - 默认隐藏 */
.mobile-view {
  display: none;
  height: 100%;
}

/* 轮播图样式 */
.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  height: 100%;
}

.carousel-slide {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-slide .show-products {
  min-width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
}

.carousel-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
  top: auto;
  transform: none;
  background: #dedee2;
  color: black;
  border: none;
  padding: 8px 12px;
  border-radius: 50px;
  cursor: pointer;
  font-size: 1rem;
  z-index: 10;
  transition: all 0.3s;
}

.carousel-btn:hover:not(:disabled) {
  background: #dedee2;
}

.prev {
  right: 70px; /* 将上一个按钮向左移动 */
}

.next {
  right: 20px; /* 下一个按钮保持在最右侧 */
}

.carousel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 调整指示器位置，避免与按钮重叠 */
.carousel-indicators {
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  margin: 0;
}

/* 响应式调整 */
@media (max-width: 765px) {
  .product-container {
    margin-top: 0px;
  }


  .web-view {
    display: none !important;
  }

  .mobile-view {
    display: block;
    height: 75vh;
  }

  .top1-image {
    height: 100px;
    margin-top: -39px;

    img {
      margin-top: 25px;
      width: 60%;
    }
  }

  .front {
    padding-left: 20px;
    width: 95%;
    margin-top: 50px;
    margin-bottom: 0px;

    p {
      font-size: 1.5em;
    }
  }

  .show-products {
    width: 90%;
    margin: 0 auto;
  }

  .show-content {
    margin-top: 10vw;
    margin-right: 90px;
  }

  .show-content2 {
    font-size: 0.85em;
  }

  .show-content3 img {
    width: 50px;
    height: 50px;
  }

  .carousel-btn {
    padding: 6px 10px;
    font-size: 1.5rem;
  }

  .prev {
    right: 60px;
  }

  .next {
    right: 15px;
  }

  .carousel-indicators {
    bottom: 25px;
  }
}
</style>
